// import { useEffect, useState } from "react";
// import {
//   Box,
//   Button,
//   CircularProgress,
//   Paper,
//   Typography,
//   Avatar,
//   Grid,
//   TextField,
// } from "@mui/material";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// import ErrorIcon from "@mui/icons-material/Error";
// import api from "../../api/axiosInterceptor";

// export default function EkycCallback() {
//   const [loading, setLoading] = useState(true);
//   const [ekycData, setEkycData] = useState(null);
//   const [error, setError] = useState("");

//   useEffect(() => {
//     const loadData = async () => {
//       try {
//         const params = new URLSearchParams(window.location.search);

//         // callback params auto received
//         const txnno = params.get("txnno");
//         const txndatetime = params.get("txndatetime");
//         const status = params.get("status");
//         const vaultrefno = params.get("vaultrefno");

//         // callback/background processing API
//         await api.get(
//           `/auth/aadhaar-response?txnno=${txnno}&txndatetime=${txndatetime}&status=${status}&vaultrefno=${vaultrefno}`
//         );

//         // only txnno used to fetch ekyc data
//         const response = await api.get(
//           `/auth/aadhaar-data?txnno=${txnno}`
//         );

//         setEkycData(response?.data?.data || response?.data);
//       } catch (err) {
//         console.error(err);
//         setError("Verification Failed");
//       } finally {
//         setLoading(false);
//       }
//     };

//     loadData();
//   }, []);

//   const handleClose = () => {
//     window.close();

//     // fallback
//     setTimeout(() => {
//       window.location.href = "/";
//     }, 1000);
//   };

//   if (loading) {
//     return (
//       <Box
//         sx={{
//           minHeight: "100vh",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           flexDirection: "column",
//           gap: 2,
//           background: "#f5f7fb",
//         }}
//       >
//         <CircularProgress />

//         <Typography fontWeight={600}>
//           Processing Aadhaar Verification...
//         </Typography>
//       </Box>
//     );
//   }

//   if (error) {
//     return (
//       <Box
//         sx={{
//           minHeight: "100vh",
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//           background: "#f5f7fb",
//           p: 2,
//         }}
//       >
//         <Paper
//           elevation={3}
//           sx={{
//             p: 4,
//             borderRadius: 4,
//             width: "100%",
//             maxWidth: 500,
//             textAlign: "center",
//           }}
//         >
//           <ErrorIcon color="error" sx={{ fontSize: 70, mb: 2 }} />

//           <Typography variant="h5" fontWeight={700} gutterBottom>
//             Verification Failed
//           </Typography>

//           <Typography color="text.secondary" mb={3}>
//             Unable to process Aadhaar verification.
//           </Typography>

//           <Button variant="contained" onClick={handleClose}>
//             OK
//           </Button>
//         </Paper>
//       </Box>
//     );
//   }

//   const ekyc = ekycData?.ekyc_data || {};

//   const fullAddress = [
//     ekyc.house,
//     ekyc.street,
//     ekyc.loc,
//     ekyc.vtc,
//     ekyc.dist,
//     ekyc.state,
//     ekyc.pc,
//     ekyc.country,
//   ]
//     .filter(Boolean)
//     .join(", ");

//   return (
//     <Box
//       sx={{
//         minHeight: "100vh",
//         background: "#f5f7fb",
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "center",
//         p: 2,
//       }}
//     >
//       <Paper
//         elevation={4}
//         sx={{
//           width: "100%",
//           maxWidth: 950,
//           borderRadius: 5,
//           overflow: "hidden",
//         }}
//       >
//         {/* Header */}
//         <Box
//           sx={{
//             background:
//               "linear-gradient(135deg, rgb(25, 118, 210), rgb(21, 101, 192))",
//             color: "#fff",
//             p: 3,
//           }}
//         >
//           <Box
//             sx={{
//               display: "flex",
//               alignItems: "center",
//               gap: 2,
//             }}
//           >
//             <CheckCircleIcon sx={{ fontSize: 45 }} />

//             <Box>
//               <Typography variant="h5" fontWeight={700}>
//                 Aadhaar Verification Successful
//               </Typography>

//               <Typography variant="body2">
//                 Your identity has been verified successfully
//               </Typography>
//             </Box>
//           </Box>
//         </Box>

//         {/* Content */}
//         <Box sx={{ p: 4 }}>
//           <Grid container spacing={4}>
//             {/* Photo */}
//             <Grid item xs={12} md={4}>
//               <Box
//                 sx={{
//                   display: "flex",
//                   justifyContent: "center",
//                 }}
//               >
//                 {ekycData?.Photo ? (
//                   <Avatar
//                     variant="rounded"
//                     src={`data:image/jpeg;base64,${ekycData.Photo}`}
//                     sx={{
//                       width: 220,
//                       height: 260,
//                       borderRadius: 4,
//                       border: "1px solid #ddd",
//                     }}
//                   />
//                 ) : (
//                   <Paper
//                     variant="outlined"
//                     sx={{
//                       width: 220,
//                       height: 260,
//                       borderRadius: 4,
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                     }}
//                   >
//                     No Photo
//                   </Paper>
//                 )}
//               </Box>
//             </Grid>

//             {/* Details */}
//             <Grid item xs={12} md={8}>
//               <Grid container spacing={2}>
//                 <Grid item xs={12} sm={6}>
//                   <TextField
//                     fullWidth
//                     label="Full Name"
//                     value={ekyc.name || ""}
//                     InputProps={{ readOnly: true }}
//                   />
//                 </Grid>

//                 <Grid item xs={12} sm={6}>
//                   <TextField
//                     fullWidth
//                     label="Date of Birth"
//                     value={ekyc.dob || ""}
//                     InputProps={{ readOnly: true }}
//                   />
//                 </Grid>

//                 <Grid item xs={12} sm={6}>
//                   <TextField
//                     fullWidth
//                     label="Father / Guardian Name"
//                     value={ekyc.co || ""}
//                     InputProps={{ readOnly: true }}
//                   />
//                 </Grid>

//                 <Grid item xs={12} sm={6}>
//                   <TextField
//                     fullWidth
//                     label="Masked Aadhaar"
//                     value={ekycData.maskedAadhaar || ""}
//                     InputProps={{ readOnly: true }}
//                   />
//                 </Grid>

//                 <Grid item xs={12} sm={6}>
//                   <TextField
//                     fullWidth
//                     label="Gender"
//                     value={ekyc.gender || ""}
//                     InputProps={{ readOnly: true }}
//                   />
//                 </Grid>

//                 <Grid item xs={12} sm={6}>
//                   <TextField
//                     fullWidth
//                     label="Verification Status"
//                     value={ekycData.status || ""}
//                     InputProps={{ readOnly: true }}
//                   />
//                 </Grid>

//                 <Grid item xs={12}>
//                   <TextField
//                     fullWidth
//                     multiline
//                     minRows={3}
//                     label="Address"
//                     value={fullAddress}
//                     InputProps={{ readOnly: true }}
//                   />
//                 </Grid>
//               </Grid>
//             </Grid>
//           </Grid>

//           {/* Footer */}
//           <Box
//             sx={{
//               mt: 4,
//               display: "flex",
//               justifyContent: "center",
//             }}
//           >
//             <Button
//               variant="contained"
//               size="large"
//               onClick={handleClose}
//               sx={{
//                 px: 6,
//                 py: 1.2,
//                 borderRadius: 3,
//                 fontWeight: 700,
//               }}
//             >
//               OK
//             </Button>
//           </Box>
//         </Box>
//       </Paper>
//     </Box>
//   );
// }



import { useEffect, useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  Paper,
  Typography,
  Avatar,
  Grid,
  TextField,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import api from "../../api/axiosInterceptor";

export default function EkycCallback() {
  const [loading, setLoading] = useState(true);
  const [ekycData, setEkycData] = useState(null);
  const [error, setError] = useState("");

  const [statusLoading, setStatusLoading] = useState(false);
  const [statusResult, setStatusResult] = useState(null);

  const [txnNo, setTxnNo] = useState("");

  useEffect(() => {
    const loadData = async () => {
      try {
        const params = new URLSearchParams(window.location.search);

        // callback params auto received
        const txnno = params.get("txnno");
        const txndatetime = params.get("txndatetime");
        const status = params.get("status");
        const vaultrefno = params.get("vaultrefno");

        setTxnNo(txnno);

        // background processing API
        await api.get(
          `/auth/aadhaar-response?txnno=${txnno}&txndatetime=${txndatetime}&status=${status}&vaultrefno=${vaultrefno}`
        );

        // fetch aadhaar data
        const response = await api.get(
          `/auth/aadhaar-data?txnno=${txnno}`
        );

        setEkycData(response?.data?.data || response?.data);
      } catch (err) {
        console.error(err);
        setError("Verification Failed");
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, []);

  const handleVerifyStatus = async () => {
    try {
      setStatusLoading(true);

      const response = await api.get(
        `/auth/aadhaar-status?txnno=${txnNo}`
      );

      setStatusResult(response.data);
    } catch (err) {
      console.error(err);

      if (err.response?.data) {
        setStatusResult(err.response.data);
      } else {
        setStatusResult({
          status: "failed",
          message: "Verification Failed",
        });
      }
    } finally {
      setStatusLoading(false);
    }
  };

  const handleClose = () => {
    window.close();

    // fallback
    setTimeout(() => {
      window.location.href = "/";
    }, 1000);
  };

  if (loading) {
    return (
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          gap: 2,
          background: "#f5f7fb",
        }}
      >
        <CircularProgress />

        <Typography fontWeight={600}>
          Processing Aadhaar Verification...
        </Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          background: "#f5f7fb",
          p: 2,
        }}
      >
        <Paper
          elevation={3}
          sx={{
            p: 4,
            borderRadius: 4,
            width: "100%",
            maxWidth: 500,
            textAlign: "center",
          }}
        >
          <ErrorIcon color="error" sx={{ fontSize: 70, mb: 2 }} />

          <Typography variant="h5" fontWeight={700} gutterBottom>
            Verification Failed
          </Typography>

          <Typography color="text.secondary" mb={3}>
            Unable to process Aadhaar verification.
          </Typography>

          <Button variant="contained" onClick={handleClose}>
            Close
          </Button>
        </Paper>
      </Box>
    );
  }

  const ekyc = ekycData?.ekyc_data || {};

  const fullAddress = [
    ekyc.house,
    ekyc.street,
    ekyc.loc,
    ekyc.vtc,
    ekyc.dist,
    ekyc.state,
    ekyc.pc,
    ekyc.country,
  ]
    .filter(Boolean)
    .join(", ");

  return (
    <Box
      sx={{
        minHeight: "100vh",
        background: "#f5f7fb",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        p: 2,
      }}
    >
      <Paper
        elevation={4}
        sx={{
          width: "100%",
          maxWidth: 950,
          borderRadius: 5,
          overflow: "hidden",
        }}
      >
        {/* Header */}
        <Box
          sx={{
            background:
              "linear-gradient(135deg, rgb(25, 118, 210), rgb(21, 101, 192))",
            color: "#fff",
            p: 3,
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
            }}
          >
            <CheckCircleIcon sx={{ fontSize: 45 }} />

            <Box>
              <Typography variant="h5" fontWeight={700}>
                Aadhaar Verification Successful
              </Typography>

              <Typography variant="body2">
                Your identity has been verified successfully
              </Typography>
            </Box>
          </Box>
        </Box>

        {/* Content */}
        <Box sx={{ p: 4 }}>
          <Grid container spacing={4}>
            {/* Photo */}
            <Grid item xs={12} md={4}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                {ekycData?.Photo ? (
                  <Avatar
                    variant="rounded"
                    src={`data:image/jpeg;base64,${ekycData.Photo}`}
                    sx={{
                      width: 220,
                      height: 260,
                      borderRadius: 4,
                      border: "1px solid #ddd",
                    }}
                  />
                ) : (
                  <Paper
                    variant="outlined"
                    sx={{
                      width: 220,
                      height: 260,
                      borderRadius: 4,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    No Photo
                  </Paper>
                )}
              </Box>
            </Grid>

            {/* Details */}
            <Grid item xs={12} md={8}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Full Name"
                    value={ekyc.name || ""}
                    InputProps={{ readOnly: true }}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Date of Birth"
                    value={ekyc.dob || ""}
                    InputProps={{ readOnly: true }}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Father / Guardian Name"
                    value={ekyc.co || ""}
                    InputProps={{ readOnly: true }}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Masked Aadhaar"
                    value={ekycData.maskedAadhaar || ""}
                    InputProps={{ readOnly: true }}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Gender"
                    value={ekyc.gender || ""}
                    InputProps={{ readOnly: true }}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Verification Status"
                    value={ekycData.status || ""}
                    InputProps={{ readOnly: true }}
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    multiline
                    minRows={3}
                    label="Address"
                    value={fullAddress}
                    InputProps={{ readOnly: true }}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          {/* Footer */}
          <Box
            sx={{
              mt: 4,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 2,
            }}
          >
            {/* Status Result */}
            {statusResult && (
              <Paper
                elevation={0}
                sx={{
                  width: "100%",
                  p: 2,
                  borderRadius: 3,
                  background:
                    statusResult.status === "success"
                      ? "#e8f5e9"
                      : "#ffebee",
                  border:
                    statusResult.status === "success"
                      ? "1px solid #66bb6a"
                      : "1px solid #ef5350",
                }}
              >
                <Typography
                  fontWeight={700}
                  color={
                    statusResult.status === "success"
                      ? "success.main"
                      : "error.main"
                  }
                  mb={1}
                >
                  {statusResult.status === "success"
                    ? "Verification Successful"
                    : "Verification Failed"}
                </Typography>

                {statusResult.aadhaar_name && (
                  <Typography variant="body2">
                    Aadhaar Name: {statusResult.aadhaar_name}
                  </Typography>
                )}

                {statusResult.match_percentage !== undefined && (
                  <Typography variant="body2">
                    Match Percentage:{" "}
                    {statusResult.match_percentage}%
                  </Typography>
                )}

                {statusResult.message && (
                  <Typography variant="body2">
                    {statusResult.message}
                  </Typography>
                )}
              </Paper>
            )}

            {/* Buttons */}
            {!statusResult ? (
              <Button
                variant="contained"
                size="large"
                onClick={handleVerifyStatus}
                disabled={statusLoading}
                sx={{
                  px: 6,
                  py: 1.2,
                  borderRadius: 3,
                  fontWeight: 700,
                }}
              >
                {statusLoading ? (
                  <CircularProgress
                    size={24}
                    color="inherit"
                  />
                ) : (
                  "OK"
                )}
              </Button>
            ) : (
              <Button
                variant="contained"
                color={
                  statusResult.status === "success"
                    ? "success"
                    : "error"
                }
                size="large"
                onClick={handleClose}
                sx={{
                  px: 6,
                  py: 1.2,
                  borderRadius: 3,
                  fontWeight: 700,
                }}
              >
                Close
              </Button>
            )}
          </Box>
        </Box>
      </Paper>
    </Box>
  );
}